export const SLACKID_ONBOARDING_PROGRESS_LOCALSTORAGE_KEY =
  'slackid-onboarding-modal-progress-localstorage-key';

export const SLACKID_ONBOARDING_MODAL_VISITS_KEY =
  'slackid-onboarding-modal-visits-key';
